@import '@core/assets/scss/partials/colors';

.MultipleChoiceQuestion {
    margin-bottom: 0;
    .SelectContainer {
        position: relative;
        width: 100%;
        border: 1px solid #ced4da;
        border-radius: 0.375rem;
        background-color: #fff;

        &.isOpen {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            z-index: 1000;
        }
    }

    .SelectToggle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #212529;
        cursor: pointer;
        min-height: 36px;

        background-color: #fff;
        transition: background-color 0.2s;
        border-radius: 0.375rem;

        &.isOpen {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }

        &:hover {
            background-color: #f8f9fa;
        }

        .ToggleContent {
            display: flex;
            align-items: center;
            flex-grow: 1;
            overflow: hidden;

            input[type='checkbox'] {
                margin-top: 0;
                margin-right: 0.5rem;
                cursor: pointer;
                flex-shrink: 0;
                width: 1rem;
                height: 1rem;

                &:disabled {
                    opacity: 1;
                    cursor: pointer;
                    filter: none;
                    background-color: #fff;

                    &:checked {
                        background-color: $primary;
                        border-color: $primary;
                    }
                }
            }
        }

        .SelectedValue {
            display: flex;
            flex-grow: 1;
            min-width: 0;
            overflow: hidden;
        }

        .TextPart {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            flex-shrink: 1;
        }

        .IndicatorPart {
            white-space: nowrap;
            flex-shrink: 0;
        }

        .MeasureSpan {
            position: absolute;
            visibility: hidden;
            white-space: nowrap;
            pointer-events: none;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            font-family: inherit;
        }

        .Chevron {
            margin-left: 0.5rem;
            color: $gray-800;
            font-size: 0.8rem;
            transition: transform 0.2s ease-in-out;

            &.rotated {
                transform: rotate(180deg);
            }
        }
    }

    .CollapseWrapper {
        position: absolute;
        top: calc(100% - 1px);
        left: -1px;
        right: -1px;
        z-index: 1000;
        background-color: #fff;
        border: 1px solid #ced4da;
        border-top: none;
        border-bottom-left-radius: 0.375rem;
        border-bottom-right-radius: 0.375rem;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        overflow: hidden;
    }

    .OptionsContainer {
        width: 100%;
        padding: 0.25rem 0;
        max-height: 300px;
        overflow-y: auto;
    }

    .CheckboxAnswer {
        display: flex;
        align-items: center;
        padding: 0.375rem 0.75rem;
        cursor: pointer;
        color: #212529;

        &:hover {
            background-color: #f8f9fa;
        }

        input[type='checkbox'] {
            margin-top: 0;
            margin-right: 0.5rem;
            cursor: pointer;
            flex-shrink: 0;
            width: 1rem;
            height: 1rem;
        }

        label {
            margin-bottom: 0;
            cursor: pointer;
            flex-grow: 1;
            font-size: 1rem;
            color: inherit;
        }
    }
}
